import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { GPKeyInitiativeEditorContent } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/gpKeyInitiatives/components/partnerView/components/gpKeyInitiativesEditor/components/gpKeyInitiativeEditorModal/components/gpKeyInitiativeEditorContent/GPKeyInitiativeEditorContent'
import { IGPKeyInitiativeForm } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/gpKeyInitiatives/components/partnerView/components/gpKeyInitiativesEditor/models/gpKeyInitiativeForm'
import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { FC, useCallback } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { TRANSLATION_KEYS } from '../../../../../../../translations'

import styles from './GPKeyInitiativeEditorModal.module.scss'

interface IGPKeyInitiativeEditorModalProps {
  initialData?: IGPKeyInitiativeForm
  isOpen: boolean
  isCommercial: boolean
  isDataInsightPresent: boolean
  isDataInsightTab?: boolean
  programType: ProgramTypes
  keyObjectivesFilter?: string
  onApply: (
    form: IGPKeyInitiativeForm,
    isInvestmentNeeds: boolean,
    needCheckAffectedLp?: boolean
  ) => Promise<void>
  onCancel: () => void
}

export const GPKeyInitiativeEditorModal: FC<IGPKeyInitiativeEditorModalProps> = ({
  initialData,
  programType,
  isOpen,
  onApply,
  isCommercial,
  isDataInsightPresent,
  isDataInsightTab,
  onCancel,
  keyObjectivesFilter,
}) => {
  const modalHeader = useCallback(() => {
    return <WidgetHeader>{TRANSLATION_KEYS.keyInitiativeEditor.keyInitiativeTitle}</WidgetHeader>
  }, [])

  if (!isOpen) {
    return null
  }

  return (
    <ModalDialog
      show={isOpen}
      onClose={onCancel}
      classes={{
        body: styles.modalBody,
        overlay: styles.closeButtonCross,
      }}
      header={modalHeader}
      closeOnOutsideClick={false}
      content={GPKeyInitiativeEditorContent}
      size="sm"
      contentProps={{
        keyObjectivesFilter,
        isDataInsightPresent,
        isDataInsightTab,
        isCommercial,
        initialData,
        programType,
        onApply,
        onCancel,
      }}
    />
  )
}
